import { FORM_VALIDATOR_TYPES } from '../constants';
import { IExamEventForm, ISubjectForm } from '../interface/examDetails.interface';

// Exam Category Enum
export enum ExamCategory {
  TEST = 'TEST',
  QUIZ = 'QUIZ',
  HOMEWORK_DUE = 'HOMEWORK_DUE',
  PROJECT_DEADLINE = 'PROJECT_DEADLINE',
  SPECIAL_EVENT = 'SPECIAL_EVENT',
}

// Exam Status Enum
export enum ExamStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
  COMPLETED = 'COMPLETED', // have to replace with POSTPONED
  CANCELLED = 'CANCELLED',
}

export enum ModalTypes {
  PUBLISH = 'PUBLISH',
  CANCEL = 'CANCEL',
  DRAFT = 'DRAFT',
}

// Exam Subject Status Enum
export enum ExamSubjectStatus {
  DRAFT = 'DRAFT',
  PENDING = 'PENDING',
  POSTPONED = 'POSTPONED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}

export enum ExamGradeStatus {
  DRAFT = 'DRAFT',
  GRADED = 'GRADED',
  INITIAL = 'INITIAL',
  ABSENT = 'ABSENT',
}

// Dropdown options for Exam Category (must be after enums)
type TFn = (key: string, def?: string) => string;
export const EXAM_CATEGORY_OPTIONS = (t: TFn) => [
  { label: t('exam.cat_test', 'Test'), value: ExamCategory.TEST },
  { label: t('exam.cat_quiz', 'Quiz'), value: ExamCategory.QUIZ },
  { label: t('exam.cat_homework_due', 'Homework Due'), value: ExamCategory.HOMEWORK_DUE },
  { label: t('exam.cat_project_deadline', 'Project Deadline'), value: ExamCategory.PROJECT_DEADLINE },
  { label: t('exam.cat_special_event', 'Special Event'), value: ExamCategory.SPECIAL_EVENT },
];

// Dropdown options for Exam Status
export const EXAM_STATUS_OPTIONS = (t: TFn) => [
  { label: t('exam.status_draft', 'Draft'), value: ExamStatus.DRAFT },
  { label: t('exam.status_published', 'Published'), value: ExamStatus.PUBLISHED },
  { label: t('exam.status_completed', 'Completed'), value: ExamStatus.COMPLETED },
  { label: t('exam.status_cancelled', 'Cancelled'), value: ExamStatus.CANCELLED },
];

export const INIT_SUBJECT: ISubjectForm = {
  markingTeacher: {
    value: '',
    validator: FORM_VALIDATOR_TYPES.TEXT,
    isRequired: true,
    error: null,
    disable: false,
  },
  subjectName: {
    value: '',
    validator: FORM_VALIDATOR_TYPES.TEXT,
    isRequired: true,
    error: null,
    disable: false,
  },
  date: {
    value: null,
    validator: FORM_VALIDATOR_TYPES.DATE,
    isRequired: true,
    error: null,
    disable: false,
  },
  startTime: {
    value: '',
    validator: FORM_VALIDATOR_TYPES.TIME,
    isRequired: true,
    error: null,
    disable: false,
  },
  endTime: {
    value: '',
    validator: FORM_VALIDATOR_TYPES.TIME,
    isRequired: true,
    error: null,
    disable: false,
  },
  status: {
    value: ExamSubjectStatus.DRAFT,
    validator: null,
    isRequired: true,
    error: null,
    disable: false,
  },
};

export const INIT_FORM: IExamEventForm = {
  title: {
    value: '',
    validator: FORM_VALIDATOR_TYPES.TEXT,
    isRequired: true,
    error: null,
    disable: false,
  },
  category: {
    value: '',
    validator: FORM_VALIDATOR_TYPES.TEXT,
    isRequired: true,
    error: null,
    disable: false,
  },
  status: {
    value: ExamStatus.DRAFT,
    validator: null,
    isRequired: false,
    error: null,
    disable: true,
  },
  curriculum: {
    value: '',
    validator: FORM_VALIDATOR_TYPES.TEXT,
    isRequired: true,
    error: null,
    disable: false,
  },
  grade: {
    value: null,
    validator: FORM_VALIDATOR_TYPES.TEXT,
    isRequired: true,
    error: null,
    disable: false,
  },
  classrooms: {
    value: null,
    validator: FORM_VALIDATOR_TYPES.ARRAY,
    isRequired: true,
    error: null,
    disable: false,
  },
  teacher: {
    value: '',
    validator: FORM_VALIDATOR_TYPES.TEXT,
    isRequired: true,
    error: null,
    disable: false,
  },
  description: {
    value: '',
    validator: FORM_VALIDATOR_TYPES.TEXT,
    isRequired: false,
    error: null,
    disable: false,
  },
  subjects: [JSON.parse(JSON.stringify(INIT_SUBJECT))],
};
